<template>
  <div class="d-flex">
    <router-link
      :to="{
        name: 'branch-pos-terminals-details',
        query: { terminalId: data.id, branchId:data.branchId, companyId:data.companyId},
      }"
    >
      <button class="btn details_btn mr-1" >View Details</button>
    </router-link>

    <!-- Reassign Modal -->

    <!-- <button class="btn details_btn w-50 mr-1 w-50" @click="reAssignPOSModal">
      {{ $t("text.clickButtons.reAssignPos") }}
    </button> -->

    <!-- Delete POS -->

    <!-- <button class="btn details_btn w-50" @click="deletePOS">
      {{ $t("text.actionButtons.delete") }}
    </button> -->
  

  
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {},
    };
  },
  mounted() {
  
  },
  methods: {
    createTerminal() {
      this.$eventHub.$emit("_createTerminal", this.data);
    },
    showPOSDetailsModal() {
      this.$eventHub.$emit("showPOSDetailsModal", this.data);
    },

    //Reassign Terminal

    // reAssignPOSModal() {
    //   this.$eventHub.$emit("_reAssignPOSModal", this.data);
    // },

    // Delete POS

    // deletePOS() {
    //   this.$eventHub.$emit("_deletePOS", this.data);
    // },
  },
};
</script>
